export const LAYOUT_CONSTANTS = {
  HEADER_HEIGHT: 80,
  SAFE_MARGIN: 24,
  CONTENT_PADDING_TOP: 104,
  MODAL_Z_INDEX: 1000,
  HEADER_Z_INDEX: 100,
  OVERLAY_Z_INDEX: 50,
} as const;
